import * as _m0 from "protobufjs/minimal";
import { SubmitCaseRequest, SubmitCaseResponse } from '../submitcase';
import { withAuthRetry } from '../utils/authRetry';

export async function submitcase(request: SubmitCaseRequest, accessToken: string, setAccessToken: (token: string | null) => void, logout: () => void): Promise<SubmitCaseResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv') === 'true';
        request.isStaging = staging; // Keep this specific logic

        const encodedRequest = SubmitCaseRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        let url = "https://li68ja5qo4.execute-api.us-west-2.amazonaws.com/intakeservice/submitcase";
        if (staging) {
            url = `${url}-staging`;
        }

        const response = await fetch(
            url, {
            method: 'POST',
            headers,
            body: base64,
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): SubmitCaseResponse => {
        return SubmitCaseResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}